export default __webpack_public_path__ + "static/media/fb_logo.7043d8f7.png";